<template>
  <div style="text-align: center; margin: auto">
    <p class="tdesk-paragraph-ultralarge tdesk-neutral-dark">
      <strong>Thank you!</strong>
    </p>
    <i class="fas fa-check-circle success" style="margin: 20px 0; font-size: 100px"></i>
    <p class="tdesk-paragraph-large tdesk-neutral-dark">
      <strong>
        Your booking is complete and you will receive an email with further
        instructions.
      </strong>
    </p>
  </div>
</template>

<script>
  export default {
    mounted() {
      this.$emit('halt-validation')
    }
  }
</script>